// LIBRARIES
// @ts-nocheck
import styled from "styled-components";

// MISC

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100vw;
  height: 100vh;
`;

export const RightSideWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
`;

export const SideMenuUnderLayer = styled.div`
  position absolute;
  width: 100%;
  height: 100%;
`;